import { effects } from 'redux-saga'
import { push as pushPath } from 'react-router-redux'

import { replaceCurrentSignup } from '../../modules/signupEdit/actions'
import { selectEditSignupWithExternals } from '../../modules/signupEdit/selectors'
import createToken from './createToken'
import updateToken from './updateToken'
import submit from './submit'

export default function* handleSubmit(apis, action) {
  let state = yield effects.select()
  const swe = yield effects.call(selectEditSignupWithExternals, state)
  let signup = swe.signup

  const paymentRequired = !swe.billingGroup || swe.billingGroup.token_required;

  if (paymentRequired) {
    if (!signup.token) {
      const {sourceId, contactDetails} = action.payload;
      const saveCardResult = yield effects.call(
        createToken,
        apis,
        signup,
        sourceId,
        contactDetails,
        (swe.billingGroup && !swe.billingGroup.token_required) || false,
      )

      if (!saveCardResult) {
        return
      }
    } else {
      const setTokenResult = yield effects.call(updateToken, apis, signup)

      if (!setTokenResult) {
        return
      }
    }
  }

  state = yield effects.select()
  signup = state.signupEdit.get('edit')

  const success = yield effects.call(submit, apis, signup, action.payload.sourceId, action.payload.contactDetails)
  if (!success) {
    return
  }

  yield effects.put.resolve(replaceCurrentSignup(null))
  yield effects.put.resolve(pushPath(`/finished/${signup.reference}`))

  yield effects.call(() => document.getElementById('wrapper').scrollIntoView())
}



// WEBPACK FOOTER //
// ./src/redux/sagas/signupEdit/handleSubmit.js